var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import {} from '../../../../_common/utils/index.js';
let DropIndicator = class DropIndicator extends LitElement {
    constructor() {
        super(...arguments);
        this.rect = null;
    }
    render() {
        if (!this.rect) {
            return null;
        }
        const { left, top, width, height } = this.rect;
        const style = styleMap({
            width: `${width}px`,
            height: `${height}px`,
            top: `${top}px`,
            left: `${left}px`,
        });
        return html `<div class="affine-drop-indicator" style=${style}></div>`;
    }
};
DropIndicator.styles = css `
    .affine-drop-indicator {
      position: absolute;
      top: 0;
      left: 0;
      background: var(--affine-primary-color);
      transition-property: height, transform;
      transition-duration: 100ms;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-delay: 0s;
      transform-origin: 0 0;
      pointer-events: none;
      z-index: 2;
    }
  `;
__decorate([
    property({ attribute: false })
], DropIndicator.prototype, "rect", void 0);
DropIndicator = __decorate([
    customElement('affine-drop-indicator')
], DropIndicator);
export { DropIndicator };
//# sourceMappingURL=drop-indicator.js.map